import React, { useEffect } from 'react'
import { selectAccountId } from '../../../../store/auth/authSlice'
import { useAppSelector } from '../../../../store/hooks'
import { createState, IntegrationServiceId } from '../../../../common/integrations'
import { getIntegrationRedirectUri } from '../../utils'

interface BaseSSOIntegrationConnectorProps {
  serviceId: IntegrationServiceId
  startConnect: boolean
  onConnected: () => void
  stateStep: string | null
  postConnectRedirectPath?: string
}

export const BaseSSOIntegrationConnector: React.FC<BaseSSOIntegrationConnectorProps> = ({
  serviceId,
  startConnect,
  onConnected,
  stateStep,
  postConnectRedirectPath,
}) => {
  const accountId = useAppSelector(selectAccountId)

  useEffect(() => {
    if (startConnect && accountId) {
      const integrationRedirectUri = getIntegrationRedirectUri(serviceId)
      const postConnectRedirectOrDefaultUri = new URL(postConnectRedirectPath ?? '/dashboard/account/integration-settings/integrations', window.location.origin)
        .href
      const state = integrationRedirectUri ? createState(postConnectRedirectOrDefaultUri, stateStep) : createState()
      const url = `${import.meta.env.REACT_APP_IAM_API_BASE_URL}/accounts/${accountId}/user-integrations/${serviceId}/enable?redirect_uri=${integrationRedirectUri}&state=${state}`
      window.location.href = url

      onConnected()
    }
  }, [startConnect, accountId, serviceId, onConnected, stateStep, postConnectRedirectPath])

  return null
}
